export const getKeyValueJSX = (title: string, value: string) => (
  <div className="flex flex-row justify-start items-center gap-3 text-xs">
    <div className="font-bold whitespace-nowrap">{title}:</div>
    <div className="ltr">{value}</div>
  </div>
);
